import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../modules/shared/services/authentication.service';
import { AuthService } from '../modules/auth/auth.service';

@Component({
    selector: 'app-no-access',
    templateUrl: './no-access.component.html',
    styleUrls: ['./no-access.component.scss'],
    standalone: false
})
export class NoAccessComponent {

  constructor(
    private router: Router,
    private authService: AuthService,
    private authenticationService: AuthenticationService
  ) {}

  goToMyTrack(): void {
    const account = this.authenticationService.getCurrentAccount();
    if (account && account.accountUID) {
      void this.router.navigate([`/${account.accountUID}/mytrack/planning`]);
    }
  }

  logout(): void {
    this.authService.logout();
  }
}
